import * as React from "react";

interface IDraggableProps {
  id: string;
  children: React.ReactNode;
  item?: object;
  onDragStart?: (event: any, item: any) => void;
  onDrop?: (event: any, item: any) => void;
  length: number;
}

const Draggable: React.FunctionComponent<IDraggableProps> = (props) => {
  const handleDrag = (ev: any) => {
    props.onDragStart?.(ev, props.item);
  };

  const handleDrop = (ev: any) => {
    props.onDrop?.(ev, props.item);
  };

  return (
    <table
      draggable={!(props.length === 0 || props.length === 1)}
      id={props.id}
      onDragOver={(ev) => ev.preventDefault()}
      onDragStart={handleDrag}
      onDrop={handleDrop}
      className="animation-move table w-100 text-nowrap"
    >
      {props.children}
    </table>
  );
};

export default Draggable;
